// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table[data-v-ef43ff1e] {\n  border-collapse: collapse;\n}\n.table tr[data-v-ef43ff1e],\n.table th[data-v-ef43ff1e],\n.table td[data-v-ef43ff1e] {\n  border: 1px solid #999;\n  padding: 10px;\n}\n.table th[data-v-ef43ff1e] {\n  background: #cecece;\n}\n", ""]);
// Exports
module.exports = exports;
